import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconButton, SxProps, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { TextIcon } from '../TextIcon';

export const testId = 'ActionButton2-test-id';
export type ActionButton2Props = {
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    icon: IconProp;
    label?: string;
    displayLabel?: boolean;
    tooltip?: boolean | string;
    color?: string;
    sx?: SxProps;
    disabled?: boolean;
};

export const ActionButton2: React.FunctionComponent<ActionButton2Props> = function ({
    onClick,
    icon,
    label = '',
    displayLabel = true,
    tooltip = false,
    color = '',
    sx,
    disabled = false,
}) {
    const hasLabel = displayLabel && label;
    const getColor = () => (!disabled ? color : 'gray');

    const buttonStyle = {
        borderRadius: '5px',
        display: 'flex',
        margin: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all ease-in-out 300ms',
        '&:hover': { backgroundColor: '#11111111' },
        ...(disabled ? { opacity: 0.5 } : {}),
        ...sx,
    };

    const labelStyle = {
        marginX: '10px',
        color: getColor(),
        ...sx,
    };

    const tooltipContent = typeof tooltip === 'string' ? tooltip : label;
    const button = (
        <IconButton
            data-testid={testId}
            onClick={onClick}
            disabled={disabled}
            sx={buttonStyle}
        >
            <TextIcon icon={{ props: { icon } }}>
                {hasLabel && <Typography sx={labelStyle}>{label}</Typography>}
            </TextIcon>
        </IconButton>
    );
    return tooltip ? <Tooltip title={tooltipContent}>{button}</Tooltip> : button;
};
